import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, ImageContainer, MessageContainer } from './styles';
import AccessDeniedImage from '../../images/access-denied.svg';
import { useEmbedding } from '../../context/embedContext';

class Unauthorized extends Component {
  render() {
    const { isEmbedded = false } = this.props;
    return (
      <Container>
        <ImageContainer>
          <img src={AccessDeniedImage} alt="access-denied" />
        </ImageContainer>
        <MessageContainer>
          <h1>403</h1>
          <h2>Access Denied</h2>
          <p>The page you're trying to access has restricted access.</p>
          {isEmbedded ? null : <Link to={'/'}>HOME</Link>}
        </MessageContainer>
      </Container>
    );
  }
}

const UnauthorizedPage = () => {
  const { embedState } = useEmbedding();
  return <Unauthorized isEmbedded={embedState.isEmbedded} />;
};

export default UnauthorizedPage;
